/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserBlackListModel(state, data) {
  if (!data) return null;
  return {
    id: lc.get(data, 'id'),
    category: lc.get(data, 'category'),
    userId: lc.get(data, 'user_id'),
    blockedUserId: lc.get(data, 'blocked_user_id'),
    causesId: lc.get(data, 'causes_id'),
    comment: lc.get(data, 'comment'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/services/UserBlackListService/restructuring/index.js